import MobileSidebar from "../MobileSidebar";
import logo from "../../assets/images/vm_logo.png";

const NavBar = () => {
  // const location = useLocation(); // Get the current location

  // Define the route(s) where the SearchBar should be visible
  // const isSearchBarVisible = location.pathname === "/dashboard/database-activity-logs";

  return (
    <section className="bg-white border-b border-b-[#EAECF0] flex w-full items-center justify-between px-4 py-3">
      <img src={logo} alt="logo" className="h-[40px]" />
      <MobileSidebar />
    </section>
  );
};

export default NavBar;
